<template>
  <div>
    <div class="tableDetail" v-for="(item, indexd) in tableData" :key="indexd">
      <div class="top" v-if="subPackageFlag == 1">
        <span class="name">{{ item.packName }}</span>
      </div>
      <div class="center">
        <p class="chlidName">
          <!-- 投标总金额(元) -->
          {{ $t("page.content.Totalamount") }}：<span style="color:#FF142F ">{{
            item.priceAmount !== ""
              ? new BigNumber(item.priceAmount).toFormat(2)
              : ""
          }}</span>
        </p>
      </div>
      <div class="ccui-multifunctional-table-wrapper">
        <!-- <div class="tableBox"> -->
        <el-table
          :data="item.sscRoundPricePackMatBOS"
          border
          :row-class-name="getClassName"
          class="ccui-multifunctional-table"
          max-height="20000"
        >
          <!-- 序号 -->
          <el-table-column
            type="index"
            :label="$t('page.content.No')"
            width="55"
            fixed
          ></el-table-column>
          <!-- 设备物质名称 -->
          <el-table-column
            prop="matName"
            :label="$t('page.content.Item')"
            min-width="120"
            show-overflow-tooltip
            fixed
          ></el-table-column>
          <!-- 设备物质说明 -->
          <el-table-column
            prop="matDesc"
            :label="$t('page.content.ItemDescription')"
            min-width="120"
            show-overflow-tooltip
            fixed
          ></el-table-column>
          <!-- 数量 -->
          <el-table-column
            prop="convPurchaseNum"
            :label="$t('page.content.QTY')"
            min-width="120"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span> {{ row.convPurchaseNum }}</span>
            </template>
          </el-table-column>
          <!-- 单位 -->
          <el-table-column
            prop="convMeasureUnitName"
            :label="$t('page.content.Unit')"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            :prop="item.convPriceAmountStr"
            :label="items.priceItem"
            min-width="120"
            v-for="(items, indexs) in item.sscRoundPricePackMatBOS[0]
              .sscSupPriceItemBOS"
            :key="items.bidPriceItemId + indexd + columnNewIndex + indexs"
          >
            <template slot-scope="{ row }">
              <!-- <span>
                  {{
                    row.sscSupPriceItemBOS[indexs].convPriceAmount | numFormat
                  }}</span
                > -->
              <span>
                {{
                  row.sscSupPriceItemBOS[indexs].convPriceAmountStr !== ""
                    ? row.sscSupPriceItemBOS[indexs].convPriceAmount.toFixed(2)
                    : ""
                }}</span
              >
            </template>
          </el-table-column>
          <!-- 综合单价（元） -->
          <el-table-column
            prop="comUnitPriceStr"
            :label="$t('page.content.UnitPrice') + '(' + moneyTypeName + '）'"
            min-width="150"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span>
                {{
                  row.comUnitPriceStr !== "" ? row.comUnitPrice.toFixed(2) : ""
                }}</span
              >
            </template>
          </el-table-column>
          <!-- 小计 -->
          <el-table-column
            prop="totalPrice"
            :label="$t('page.content.Total') + '(' + moneyTypeName + '）'"
            min-width="120"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span>
                {{
                  row.totalPrice !== ""
                    ? new BigNumber(row.totalPrice).toFormat(2)
                    : ""
                }}</span
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import BigNumber from "bignumber.js";
export default {
  props: {
    moneyTypeName: {
      type: String,
      default() {
        return "";
      }
    },
    tableData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  mounted() {
    this.subPackageFlag = JSON.parse(sessionStorage.getItem("subPackageFlag"));
  },
  data() {
    return {
      BigNumber: BigNumber,
      total: 0,
      columnNewIndex: 0,
      subPackageFlag: ""
    };
  },
  methods: {
    getClassName({ row, rowIndex }) {
      this.columnNewIndex = rowIndex;
    }
  },
  watch: {
    tableData: {
      handler(n) {
        n.forEach(f => {
          f.sscRoundPricePackMatBOS.forEach(g => {
            g.sscSupPriceItemBOS.forEach(h => {
              if (h.convPriceAmountStr == "") {
                g.comUnitPriceStr = "";
                g.totalPrice = "";
                f.priceAmount = "";
              }
            });
          });
        });
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
.tableDetail {
  padding-bottom: 10px;
  border: 1px solid #edf2fc;
  margin-top: 15px;
  .top {
    padding: 0px 10px;
    height: 40px;
    line-height: 40px;
    color: #4a4a4a;
    .name {
      padding-right: 20px;
      font-size: 14px;
      word-break: break-all;
    }
  }
  .center {
    padding: 10px 10px;
    color: #4a4a4a;
    font-size: 14px;
  }
  .footer {
    padding: 10px 10px;
    color: #4a4a4a;
    font-size: 14px;
    .chlidName {
      padding-bottom: 10px;
    }
    .tableBox {
      padding: 0px 20px;
    }
  }
}
/deep/.el-table__row {
  line-height: 36px;
  height: 36px;
}
/deep/.el-table {
  border-collapse: collapse;
}
/deep/.el-table td,
.el-table th.is-leaf {
  border-right: 1px solid #edf2fc !important;
}
/deep/.ccui-multifunctional-table-wrapper {
  padding: 0px 20px;
  .el-table__header th {
    border-right: 1px solid #edf2fc !important;
  }
}
</style>
